// To use the following function to calculate the position,
// the paddings around cards-intro need to be set for itself
// Remove margin botton for the paragraph

document.addEventListener("DOMContentLoaded", function () {
	function updateHeight() {
		const element = document.querySelector(".cards-intro");
		const pagination = document.querySelector(".splide__pagination");

		// If essential elements are not found, exit.
		if (!element || !pagination) {
			// console.warn("Pagination positioning: Required elements .cards-intro or .splide__pagination not found.");
			return;
		}

		// Use requestAnimationFrame to ensure dimensions are read after layout updates.
		requestAnimationFrame(function () {
			const elementHeight = element.offsetHeight;
			const paddingBottom = parseFloat(
				window.getComputedStyle(element).paddingBottom
			);
			const paginationHeight = parseFloat(pagination.offsetHeight);

			// Ensure all values are valid numbers before calculation
			if (
				isNaN(elementHeight) ||
				isNaN(paddingBottom) ||
				isNaN(paginationHeight)
			) {
				// console.warn("Pagination positioning: Invalid dimension values obtained.");
				return;
			}

			let newTopPosition =
				elementHeight - (paddingBottom + paginationHeight) / 2;

			pagination.style.setProperty("top", `${newTopPosition}px`);
		});
	}

	updateHeight();
	window.addEventListener("resize", updateHeight);
});
